export const DEVELOPER_DOCS_URL = 'http://developers.maestro.io/';
export const CODE_INJECTION_HELP_URL = 'https://support.maestro.io/knowledge/using-code-injection';
